import { useRef, useEffect } from 'react'

export function DotGrid() {
	const glowRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const glowEl = glowRef.current
		if (!glowEl) return

		const section = glowEl.closest('section')
		if (!section) return

		const hide = 'radial-gradient(circle 0px at 0 0, black, transparent)'

		function handleMouseMove(e: MouseEvent) {
			if (!glowEl) return
			const rect = section!.getBoundingClientRect()
			const x = e.clientX - rect.left
			const y = e.clientY - rect.top

			if (
				x < -300 ||
				y < -300 ||
				x > rect.width + 300 ||
				y > rect.height + 300
			) {
				glowEl.style.maskImage = hide
				glowEl.style.webkitMaskImage = hide
				return
			}

			const mask = `radial-gradient(circle 300px at ${x}px ${y}px, black 0%, black 30%, transparent 80%)`
			glowEl.style.maskImage = mask
			glowEl.style.webkitMaskImage = mask
		}

		window.addEventListener('mousemove', handleMouseMove)

		return () => {
			window.removeEventListener('mousemove', handleMouseMove)
		}
	}, [])

	return (
		<>
			<div className="absolute inset-0 bg-dot-pattern opacity-[0.06]" />
			<div
				ref={glowRef}
				className="absolute inset-0 bg-dot-pattern-glow opacity-[0.8]"
				style={{ maskImage: 'radial-gradient(circle 0px at 0 0, black, transparent)', WebkitMaskImage: 'radial-gradient(circle 0px at 0 0, black, transparent)' }}
			/>
		</>
	)
}
